
const authStore = {
    isLoggedIn: true,
    userDetails: {},
    token: {},
    menuItems: {},
    orgId: '',
    sellerCreation: false,
    accountType: 'user',
    buyNow: [],
    accountDetails: {},
    region: {},
    currentDeliveryAddress: {}
}

export default authStore